import React from "react";
import { GET_FILE_UPLOAD } from "api/ApiConstants";

const FlightTicketAdditionalInfo = (props) => {
  return (
    <div className="flight-ticket-additional-info">
      <div className="terms-and-conditions">
        <h3 style={{ textAlign: "center", textDecoration: "underline" }}>
          Terms and conditions
        </h3>
        <p>* All Travel timings are as per the local time in 24 hrs format</p>
        <p>* Check passenger name and Travel Itinerary details carefully</p>
        <p>
          * Names provided should be with Valid Government Approved Photo ID/
          Passport
        </p>
        <p>* Automated Ticketing time limit provided as per airline</p>
        <p>
          * Ensure Sufficient Funds are available for confirmation of services
        </p>
        <p>
          * Fares and Taxes are subject to availability at the time of issuance
        </p>
        <p>
          * We are not liable if any increase occurs due to ROE fluctuation and
          taxes
        </p>
        <p>
          * Check all Visa requirement for Destination and Transit country with
          the respective airline and embassy
        </p>
        <p>
          * You must web check-in on the airline website and obtain a boarding
          pass.
        </p>
        <p>
          * Reach the terminal at least 2 hours prior to the departure for
          domestic flight and 4 hours prior to the departure of international
          flight.
        </p>
        <p>* For departure terminal please check with the airline first.</p>
        <p>
          * Date & Time is calculated based on the local time of the
          city/destination.
        </p>
        <p>
          * Use the Airline PNR for all Correspondence directly with the Airline
        </p>
        <p>
          * For rescheduling/cancellation within 4 hours of the departure time
          contact the airline directly
        </p>
        <p>
          * Your ability to travel is at the sole discretion of the airport
          authorities and we shall not be held responsible
        </p>
      </div>
      <div className="do-and-do-nots">
        <img
          style={{ width: "100%" }}
          src={`${GET_FILE_UPLOAD}?fileName=restricted_items.png&type=EMAIL_IMAGES`}
        />
      </div>
    </div>
  );
};

export default FlightTicketAdditionalInfo;
